import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash.get';
import { createFragmentContainer, graphql } from 'react-relay';
import { FormattedMessage } from 'react-intl';
import CartButton from './CartButton';
import tracking from 'dibs-tracking';

function CartCheckoutOfferButton({ item, transaction, trackingLabel }) {
    const checkoutUrl = `/checkout/id-${item.serviceId}?acceptOffer=true`;
    let ctaCopy;

    if (get(transaction, 'hasDealerSubmittedOfferAction')) {
        ctaCopy = (
            <FormattedMessage
                id="CartCheckoutOfferButton.acceptOffer"
                defaultMessage="Accept Offer"
            />
        );
    } else if (get(transaction, 'hasAcceptedBuyerOfferAction')) {
        ctaCopy = (
            <FormattedMessage
                id="CartCheckoutOfferButton.purchaseNow"
                defaultMessage="Purchase Now"
            />
        );
    }

    return (
        <CartButton
            href={checkoutUrl}
            onClick={() => {
                tracking.trackEvent({
                    action: 'accept offer button-cart',
                    category: 'purchase click',
                    label: trackingLabel,
                });
                return true;
            }}
        >
            {ctaCopy}
        </CartButton>
    );
}

CartCheckoutOfferButton.propTypes = {
    item: PropTypes.object.isRequired,
    transaction: PropTypes.object.isRequired,
    trackingLabel: PropTypes.string.isRequired,
};

export default createFragmentContainer(CartCheckoutOfferButton, {
    item: graphql`
        fragment CartCheckoutOfferButton_item on Item {
            serviceId
        }
    `,
    transaction: graphql`
        fragment CartCheckoutOfferButton_transaction on Transaction {
            hasDealerSubmittedOfferAction: hasAction(
                actionCode: "BUYER_CHECKOUT_SUBMITTED_DEALER_OFFER"
            )
            hasAcceptedBuyerOfferAction: hasAction(
                actionCode: "BUYER_CHECKOUT_ACCEPTED_BUYER_OFFER"
            )
        }
    `,
});
